import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

const RegisterPage: React.FC = () => {
  const { register } = useAuth();
  const { cartItems } = useCart();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    re_password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (form.password !== form.re_password) {
      setError('Las contraseñas no coinciden');
      return;
    }
    setLoading(true);
    try {
      await register(form);
      if (cartItems.length > 0) navigate('/checkout'); else navigate('/');
    } catch (err: any) {
      const apiErr = err?.response?.data;
      const firstMsg = typeof apiErr === 'object' ? Object.values(apiErr)[0] : null;
      setError((Array.isArray(firstMsg) ? firstMsg[0] : firstMsg) || 'No se pudo registrar.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4 md:p-12 min-h-screen pt-[96px]" style={{ backgroundColor: '#FFFBF7' }}>
      <h1 className="text-3xl font-semibold text-gray-800 mb-8">Crear cuenta</h1>
      <form onSubmit={handleSubmit} className="bg-white p-6 shadow-md rounded-lg max-w-md">
        {error && <div className="mb-4 text-red-600">{error}</div>}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input name="email" type="email" required value={form.email} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Nombre</label>
          <input name="first_name" type="text" required value={form.first_name} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Apellido</label>
          <input name="last_name" type="text" required value={form.last_name} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Contraseña</label>
          <input name="password" type="password" required value={form.password} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700">Repetir contraseña</label>
          <input name="re_password" type="password" required value={form.re_password} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
        </div>
        <button type="submit" disabled={loading} className="w-full bg-pink-dark text-white py-3 rounded-lg font-semibold hover:bg-pink-700 transition-colors disabled:opacity-50">
          {loading ? 'Creando…' : 'Crear cuenta'}
        </button>
      </form>
    </div>
  );
};

export default RegisterPage;
